// import {styled} from '@mui/material/styles';

import SilverContext from '../../context/silver'

import Foot from '../Foot'
import AppBar from '../AppBar'
// import Protocol from '../Protocol'
// import { withRouter } from 'react-router-dom';

function Home() {
    return (
        <SilverContext>
            <AppBar />
            <Foot />
            {/* <Protocol /> */}
        </SilverContext>
    )
}

// export default withRouter(Home)
export default Home

// const FootWraper = styled('div')`
//     width: 100%;
//     position: relative;
//     height: ${p => p.h || '34px'};
// `